<template>
  <div class="global-box">
    <oie-use-svg svg="logo-large" class="global-box__logo-svg"></oie-use-svg>

    <div class="global-box__actions">
      <a
        v-for="market of markets"
        :key="market.name"
        href="#0"
        class="button button-link button-link--ghost">
        <oie-use-svg :svg="market.icon"></oie-use-svg>
        {{ market.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    markets: [
      { name: 'Sverige', icon: 'se' },
      { name: 'Soumi', icon: 'fi' },
      { name: 'Denmark', icon: 'dk' },
      { name: 'Norge', icon: 'no' },
      { name: 'EU', icon: 'eu' }
    ]
  })
}
</script>
